import {
  AfterViewInit,
  Directive,
  ElementRef,
  Renderer2,
  ChangeDetectorRef
} from '@angular/core';

@Directive({
  selector: '[appCustomDropdownTable]'
})
export class CustomDropdownTableDirective implements AfterViewInit {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.customDropdown();
  }

  customDropdown() {
    this.renderer.setStyle(this.el.nativeElement, 'position', 'static');
    const dropdownActions = this.el.nativeElement.querySelector('.dropdown-menu');
    this.renderer.setStyle(dropdownActions, 'width', 'fit-content');
    this.renderer.setStyle(dropdownActions, 'min-width', 'fit-content');
    this.renderer.setStyle(dropdownActions, 'box-shadow', 'rgba(0, 0, 0, 0.08) 0px 4px 11px 0px');
    this.renderer.setStyle(dropdownActions, 'border-radius', '6px');
  }
  
}
